module.exports = {"id":"212519","name":"Romain Philippoteaux","rating":"73","photo":"./data/images/photos/2/212519.png","club":{"name":"AJ Auxerre","logo":"./data/images/clubs/AJAuxerre.png"},"positions":["MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RomainPhilippoteaux0.json
// module id = 3690
// module chunks = 0